import colors from 'assets/theme/base/colors';
import typography from 'assets/theme/base/typography';

const { size, fontWeightRegular } = typography;

const formControlLabel = {
    styleOverrides: {
        label: {
            fontSize: size.sm,
            fontWeight: fontWeightRegular,
            color: colors.common.white,
            //lineHeight: 1,
            //transform: `translateY(${pxToRem(100)})`,

            '&.Mui-disabled': {
                //color: dark.main,
            },
        },
    },
};

export default formControlLabel;
